import axiosClient from "utils/axios";
import { ApiResponse } from "types/api.types";
import {
  Attachment,
  AttachmentListParams,
  AttachmentsTableResponse,
  UploadAttachmentsInput,
} from "features/Attachments/types/attachment.types";

const ATTACHMENT_BASE_PATH = "/attachments";

export const getAttachments = async (input: AttachmentListParams) => {
  try {
    const response = await axiosClient.get<ApiResponse<AttachmentsTableResponse>>(
      ATTACHMENT_BASE_PATH,
      {
        params: {
          sourceType: input.sourceType,
          sourceId: input.sourceId,
          page: input.page,
          limit: input.limit,
        },
      },
    );
    return response.data;
  } catch (err) {
    console.warn("Error fetching attachments : ", err);
    throw err;
  }
};

/** multipart/form-data — sourceType, sourceId, description?, files[] (1–10). */
export const uploadAttachments = async (input: UploadAttachmentsInput) => {
  try {
    const fd = new FormData();
    fd.append("sourceType", input.sourceType);
    fd.append("sourceId", String(input.sourceId));
    if (input.description?.trim()) {
      fd.append("description", input.description.trim());
    }
    input.files.forEach((file) => fd.append("files", file));

    const response = await axiosClient.post<ApiResponse<Attachment[]>>(
      ATTACHMENT_BASE_PATH,
      fd,
    );
    return response.data;
  } catch (err) {
    console.warn("Error uploading attachments : ", err);
    throw err;
  }
};

export const deleteAttachment = async (id: number) => {
  try {
    const response = await axiosClient.delete<ApiResponse<Attachment>>(
      `${ATTACHMENT_BASE_PATH}/${id}`,
    );
    return response.data;
  } catch (err) {
    console.warn("Error deleting attachment : ", err);
    throw err;
  }
};
